var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-list-item',[_c('mu-list-item-action',[(!_vm.processing)?_c('mu-circular-progress',{attrs:{"mode":"determinate","value":_vm.uploadProgress}}):_c('mu-circular-progress')],1),_c('mu-list-item-content',[_c('mu-list-item-title',[_vm._v("\n      "+_vm._s(_vm.$t('notification.' + (_vm.processing ? 'process' : 'upload'), {
        object: _vm.upload.text
      }))+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }